import LabeledDataItem from "./LabeledDataItem";

export { LabeledDataItem };
